import { FC, useState } from 'react';

interface CustomDropdownProps {
  button: JSX.Element | string;
  options: {
    name: string;
    icon?: string;
    onClick: () => void;
  }[];
}

const CustomDropdown: FC<CustomDropdownProps> = ({ button, options }) => {
  const [show, setShow] = useState(false);

  const handleMouseLeave = (e: React.MouseEvent<HTMLDivElement>) => {
    const target = e.relatedTarget as HTMLElement;
    if (!target?.classList.contains('dropdown')) {
      setShow(false);
    }
  };

  return (
    <div className="dropdown z-5" onMouseLeave={handleMouseLeave}>
      <div
        onMouseEnter={() => setShow(true)}
        aria-expanded="true"
        aria-haspopup="true"
        className="btn btn-sm text-muted p-1 py-0 text-decoration-none fs-15 show"
        data-bs-toggle="dropdown"
        role="button"
      >
        {button}
      </div>
      {show && (
        <div
          className="dropdown-menu dropdown-menu-end show position-absolute z-3 translate-middle-x"
          onClick={e => e.stopPropagation()}
        >
          {options.map(({ name, icon, onClick }, index) => (
            <>
              <div
                key={name}
                onClick={e => {
                  e.stopPropagation();
                  onClick();
                }}
                className="dropdown-item"
                role="button"
              >
                {icon && <i className={`${icon} align-bottom me-2 text-muted`} />}
                {name}
              </div>
              {index !== options.length - 1 && <div className="dropdown-divider" />}
            </>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
